import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Phase 3b polish — footer no longer opens the sign-in disambig modal;
// deep-links go straight to the role-specific magic-link request page.
export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="lg-footer" data-testid="lg-footer">
            <div className="footer-inner">
                <div className="footer-top">
                    <div>
                        <Link
                            to="/"
                            className="footer-logo"
                            data-testid="footer-logo"
                            style={{ textDecoration: "none", color: "inherit" }}
                        >
                            Laguna<span>.</span>
                        </Link>
                        <div className="footer-tag">{t("footer.tagline")}</div>
                    </div>
                    <div className="footer-meta">
                        <div className="footer-col">
                            <h5>{t("footer.productHeading")}</h5>
                            <Link to="/employers" data-testid="footer-employers">
                                {t("footer.productLinks.employers")}
                            </Link>
                            <Link to="/how-it-works" data-testid="footer-how-it-works">
                                {t("footer.productLinks.howItWorks")}
                            </Link>
                            <Link to="/employees" data-testid="footer-employees">
                                {t("footer.productLinks.employees")}
                            </Link>
                        </div>
                        <div className="footer-col">
                            <h5>{t("footer.accountHeading")}</h5>
                            <Link
                                to="/apply"
                                data-testid="footer-employee-login"
                            >
                                {t("footer.accountLinks.employeeLogin")}
                            </Link>
                            <Link
                                to="/employer-signin"
                                data-testid="footer-employer-login"
                            >
                                {t("footer.accountLinks.employerLogin")}
                            </Link>
                        </div>
                        <div className="footer-col">
                            <h5>{t("footer.companyHeading")}</h5>
                            <Link to="/about" data-testid="footer-about">
                                {t("footer.companyLinks.about")}
                            </Link>
                            <Link to="/faq" data-testid="footer-faq">
                                {t("footer.companyLinks.faq")}
                            </Link>
                            <Link to="/privacy" data-testid="footer-privacy">
                                {t("footer.companyLinks.privacy")}
                            </Link>
                            <Link to="/terms" data-testid="footer-terms">
                                {t("footer.companyLinks.terms")}
                            </Link>
                        </div>
                    </div>
                </div>
                {/* LEGAL — human translation required before launch for ES. */}
                <div className="footer-disclaimer" data-testid="footer-disclaimer">
                    {t("footer.disclaimer")}
                    <br />
                    <br />
                    <em style={{ color: "var(--muted)" }}>{t("footer.governance")}</em>
                </div>
            </div>
        </footer>
    );
}
